module.exports = __webpack_public_path__ + "static/media/media1.bdf75cab.jpg";